import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import aluzonLogo from '../assets/ALUzon Logo.png';

const QUICK_LINK_PATHS = new Set(['/dashboard', '/news', '/venues', '/request-assistance', '/my-requests', '/account']);

const SUPPORT_ITEMS = [
  { label: 'Support Hotline', value: '(02) 8123 4567' },
  { label: 'Email', value: 'support@laborconnect.ph', href: 'mailto:support@laborconnect.ph' },
  { label: 'Office Hours', value: 'Mon - Fri, 8:00 AM - 5:00 PM' },
];

export default function Footer({ navItems, onNavigate }) {
  const currentYear = new Date().getFullYear();
  const quickLinks = Array.isArray(navItems)
    ? navItems.filter((item) => QUICK_LINK_PATHS.has(item.path))
    : [];

  const handleNavigate = (path, state) => {
    if (typeof onNavigate === 'function') {
      onNavigate(path, state);
    }
  };

  return (
    <footer className="app-footer" role="contentinfo">
      <div className="app-footer__inner">
        <div className="app-footer__brand">
          <img src={aluzonLogo} alt="LaborConnect Logo" className="app-footer__brand-logo" />
          <div className="app-footer__brand-text">
            <h4>LaborConnect</h4>
            <p>Member Portal and Assistance Platform</p>
          </div>
        </div>

        <div className="app-footer__col">
          <h5>Quick Links</h5>
          <ul>
            {quickLinks.map((item) => (
              <li key={item.path}>
                <button
                  type="button"
                  className="app-footer__link-button"
                  onClick={() => handleNavigate(item.path)}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="app-footer__col">
          <h5>Support</h5>
          <button
            type="button"
            className="app-footer__link-button app-footer__support-cta"
            onClick={() => handleNavigate('/account', { openSupportModal: true })}
          >
            Contact support
          </button>
          <ul className="app-footer__support-list">
            {SUPPORT_ITEMS.map((item) => (
              <li key={item.label} className="app-footer__support-item">
                <span className="app-footer__support-label">{item.label}</span>
                {item.href ? (
                  <a className="app-footer__support-value app-footer__link" href={item.href}>
                    {item.value}
                  </a>
                ) : (
                  <span className="app-footer__support-value">{item.value}</span>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="app-footer__bottom">
        <span className="app-footer__copyright">
          Copyright © {currentYear} LaborConnect. All rights reserved.
        </span>
        <div className="app-footer__legal" aria-label="Legal links">
          <Link to="/privacy-policy" className="app-footer__link">
            Data Privacy Policy
          </Link>
          <span aria-hidden="true">•</span>
          <Link to="/terms-and-conditions" className="app-footer__link">
            Terms &amp; Conditions
          </Link>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  navItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      path: PropTypes.string,
    }),
  ),
  onNavigate: PropTypes.func,
};

Footer.defaultProps = {
  navItems: [],
  onNavigate: null,
};
